import FormItem from 'antd/es/form/FormItem';
// export default withConfigProvider(FormItem);
export default FormItem;
